import React, { useEffect, useState} from 'react';
import './OperationsPage.css';
import { 
  Card,
  Col,
  Grid,
  Title,
  TextInput,
  Dropdown,
  DropdownItem,
  Text,
  Divider,
  Metric,
  Button,
  DateRangePicker,
  DateRangePickerValue,
  Flex,
  Toggle,
  ToggleItem,
} from "@tremor/react";
import ReactPaginate from 'react-paginate';
import SidebarComponent from '../components/SidebarComponent';
import TitleComponent from '../components/TitleComponent';
import OperationsTableComponent from '../components/OperationsTableComponent';
import { ShortOrder } from '../interfaces/OrderInterfaces';
import axios from 'axios';
import { useCookies } from 'react-cookie';
import { Drivers, Organization, User } from '../interfaces/AccessInterfaces';
import { ptBR } from "date-fns/locale";
import { Link } from "react-router-dom";
import { getTransporterClients } from '../api';

export default function OperationsPage({drivers}:{drivers:Drivers}) {
  const [cookies] = useCookies(['mazelog-user']);
  const token = cookies['mazelog-user']?.token_data?.access_token;
  const oauth = "Bearer " + token;
  const userProfile = cookies['mazelog-user']?.user_data?.user_profile;
  const isTransporter = userProfile === "TRANSPORTER" || userProfile === "TRANSPORTER_COLLECTER"
  const isClient = userProfile === "CLIENT"
  const orgId = cookies["mazelog-user"]?.organization_data?.id_org;
  const baseURL = process.env.REACT_APP_MAZELOG_SYSTEM_BASE_URL;

  const now = new Date();

  const [requested, setRequested] = useState<boolean>(false);
  const [orders, setOrders] = useState<ShortOrder[]>([]);
  const [countOrders, setCountOrders] = useState<number>(0);
  const [expansions, setExpansions] = useState<number>(0);
  const [moreOrdersToShow, setMoreOrdersToShow] = useState<boolean>(true);
  const [selectedNumber, setSelectedNumber] = useState<string>('');
  const [selectedReceipt, setSelectedReceipt] = useState<string>('');
  const [selectedStatus, setSelectedStatus] = useState<string>('all');
  const [selectedSender, setSelectedSender] = useState<string>('');
  const [selectedReceiver, setSelectedReceiver] = useState<string>('');
  const [selectedTransporter, setSelectedTransporter] = useState<string>('all');
  const [selectedDriver, setSelectedDriver] = useState<number>();
  const [wrongDriverId, setWrongDriverId] = useState<boolean>(false);
  const [selectedDateRange, setSelectedDateRange] = useState<DateRangePickerValue>([
    new Date(now.getFullYear(), now.getMonth(), now.getDate() - 7),
    now
  ]);
  const [filterByDate, setFilterByDate] = useState<string>("emission");
  const [statusChannel, setStatusChannel] = useState<string>('all');
  const [transporterClients, setTransporterClients] = useState<Organization[]>([]);
  const [selectedTransporterClients, setSelectedTransporterClients] = useState<string>('-1');
  const [selectedUser, setSelectedUser] = useState<string>("");
  const [users, setUsers] = useState<User[]>([]);
  const [selectedSource, setSelectedSource] = useState<string>('all');

  const [page, setPage] = useState<number>(0);
  const [searchedOrders, setSearchedOrders] = useState<ShortOrder[]>([]);
  const [totalInternal, setTotalInternal] = useState<number>(0);
  const [totalMeli, setTotalMeli] = useState<number>(0);
  const [totalShopee, setTotalShopee] = useState<number>(0);
  const [totalUnk, setTotalUnk] = useState<number>(0);
  
  const handleSubmit = async (pageSelected: number = 0) => {
    setRequested(true);
    
    try {
        let URL = `${baseURL}/order/query?${filterByDate}_start_date=${selectedDateRange[0]?.toISOString()}&${filterByDate}_end_date=${selectedDateRange[1]?.toISOString()}`;
        
        if (selectedNumber !== '') URL = `${baseURL}/order/query?order_number=${selectedNumber}`;
        else {
          if (selectedReceipt !== '') URL += `&receipt_number=${selectedReceipt}`;
          if (selectedStatus !== 'all') URL += `&status=${selectedStatus}`;
          if (selectedSender !== '') URL += `&sender_document=${selectedSender}`;
          if (selectedReceiver !== '') URL += `&receiver_document=${selectedReceiver}`;
          if (selectedTransporter !== 'all') URL += `&transporter=${selectedTransporter}`;
          if (selectedSource !== 'all') URL += `&source=${selectedSource}`;
          if (selectedDriver) URL += `&courier_id_user=${selectedDriver}`;
          if (selectedUser) URL += `&courier_id_user=${selectedUser}`;
          if (selectedTransporterClients !== '-1') URL += `&created_by_id_org=${selectedTransporterClients}`;
          if (statusChannel !== 'all') {
              const [status, subStatus] = statusChannel.split("|");
              URL += `&meli_status=${status}`;
              if (subStatus) {
                  URL += `&meli_substatus=${subStatus}`;
              }
          }
        }
        URL += `&page=${pageSelected}`;

        const res = await axios.get(URL, {
            headers: { accept: 'application/json', "Authorization": oauth }
        });


        setSearchedOrders(res.data.results);
        setTotalInternal(res.data.total_internal);
        setTotalMeli(res.data.total_meli);
        setTotalShopee(res.data.total_shopee);
        setTotalUnk(res.data.total_unk);
        
        // return res.data.length;
    } catch (err) {
        console.log(err);
    } finally {
        setRequested(false);
    }
};

  const handleFilter = async () => {
    setTotalInternal(0);
    setTotalMeli(0);
    await handleSubmit()
    setPage(0);
  }

  const calculatePageCount = () => {
    let page_size = 50;
    return Math.ceil( Math.max(totalInternal, totalMeli, totalShopee, totalUnk) / page_size);
  };


  const loadTransporterClients = async () => {
    const transporterUserName = cookies['mazelog-user']?.organization_data?.name || '';
    if (transporterUserName && isTransporter) {
      const res = await getTransporterClients(oauth, transporterUserName);
      res.unshift({
        id_org: -1, name: "Todos os clientes",
        cnpj: '',
        prefix: '',
        profile: '',
        product_flag: false,
        whatsapp_flag: false,
        email_flag: false,
        spreadsheet: false,
        correios: false,
        flag_router: false
      });
      setTransporterClients(res);
    } 
  }

  
    const getUsers = () => {
      const baseURL = process.env.REACT_APP_MAZELOG_AUTH_BASE_URL;
      const oauth = "Bearer " + token;
  
      let url = `${baseURL}/users`;
      if (isTransporter) {
        url = `${baseURL}/users/company/${orgId}`;
      }
  
      axios.get(url,
        {headers: {accept: 'application/json', "Authorization": oauth}}
      )
      .then((res)=>{
        console.log(res);
        setUsers(res.data.data);
      })
      .catch((err)=>{
        console.log(err);
      })
    }

  useEffect(() => {
    setCountOrders(searchedOrders.length);
  }, [searchedOrders])

  useEffect(() => {
    // if (!requested) handleSubmit();
    getUsers();
    loadTransporterClients();
  }, []); 

  return (
    <main className="Page">
    <SidebarComponent />
    <div className="Content">
      <TitleComponent />
      <div className="OpsViews">
        <Card className="mt-6">
          <Grid numCols={2} className="gap-2">
                  <Col numColSpan={1}>
                    <Title>ID do pedido</Title>
                    <TextInput className='max-w-md' onChange={(e) => setSelectedNumber(e.target.value)}/>
                  </Col>
                  <Col numColSpan={1}>
                    <Title>Número da nota</Title>
                    <TextInput
                      placeholder='0000000000'
                      className='max-w-md'
                      onChange={(e) => setSelectedReceipt(e.target.value)}
                    />
                  </Col>
                  { !isTransporter && (
                    <Col numColSpan={1}>
                      <Title>CNPJ remetente</Title>
                      <TextInput placeholder="00.000.000/0000-00" className='max-w-md' onChange={(e) => setSelectedSender(e.target.value)}/>
                    </Col>
                  )}
                  <Col numColSpan={1}>
                    <Title>CNPJ/CPF destinatário</Title>
                    <TextInput placeholder="00.000.000/0000-00" className='max-w-md' onChange={(e) => setSelectedReceiver(e.target.value)}/>                  
                  </Col>
                  {(!isClient) && (
                    // <Col numColSpan={1}>
                    //   <Title>Email entregador</Title>
                    //   <TextInput className='max-w-md' error={wrongDriverId} onChange={(e) => driverFilterHandler(e.target.value)}/>
                    // </Col>
                    <Col numColSpan={1}>
                        <Title>Motorista</Title>
                        <div className="flex items-center justify-between">
                            <Dropdown
                                className="max-w-md"
                                value={selectedUser}
                                onValueChange={(value) => setSelectedUser(value)}
                                placeholder="Selecione um usuário"
                                >
                                {[
                                    <DropdownItem key="none" value="" text="Nenhum" />,
                                    ...users
                                    .filter(x => x.user_profile === "TRANSPORTER" || x.user_profile === "TRANSPORTER_COLLECTER")
                                    .map((item) => (
                                        <DropdownItem
                                        key={item.id_user}
                                        value={item.id_user?.toString() ?? ""}
                                        text={item.email}
                                        />
                                    )),
                                ]}
                            </Dropdown>
                        </div>
                    </Col>
                  )}
                  {(!isTransporter && !isClient) && (
                    <Col numColSpan={1}>
                      <Title>Transportadora</Title>
                      <Dropdown
                        className="max-w-md"
                        defaultValue="all"
                        onValueChange={(value) => setSelectedTransporter(value)}
                      >
                        <DropdownItem value="all" text="Todas as transportadoras" />
                        <DropdownItem value="none" text="N/A" />
                        <DropdownItem value="flashExpress" text="Flash Express" />
                        <DropdownItem value="arrFlex" text="ARR Flex" />
                      </Dropdown>
                    </Col>
                  )}
                  { isTransporter && (
                    <Col numColSpan={1}>
                      <Title>Cliente</Title>
                      <Dropdown
                        className="max-w-md"
                        defaultValue="-1"
                        onValueChange={(value) => setSelectedTransporterClients(value)}
                      >
                          {transporterClients.map((client) => (
                            <DropdownItem value={String(client.id_org)} text={client.name} />
                          ))}
                      </Dropdown>
                    </Col>
                  )}
                  <Col numColSpan={1}>
                    <Title>Canal</Title>
                    <Dropdown
                        className='max-w-md'
                        defaultValue="all"
                        onValueChange={(value) => { setSelectedSource(value); setStatusChannel("all"); }}
                    >
                        <DropdownItem value="all" text="Todos os canais" />
                        <DropdownItem value="mazelog" text="Mazelog" />
                        <DropdownItem value="mercado_livre" text="Mercado Livre" />
                        <DropdownItem value="shopee" text="Shopee" />
                        <DropdownItem value="unknown" text="Avulso" />
                    </Dropdown>
                  </Col>
                  <Col numColSpan={1}>
                  <Title>Data de {filterByDate === "emission" ? "criação" : "atualização"}</Title>
                    <DateRangePicker
                      className="max-w-md"
                      value={selectedDateRange}
                      onValueChange={setSelectedDateRange}
                      locale={ptBR}
                      dropdownPlaceholder="Selecionar"
                      enableYearPagination={true}
                    />
                  </Col>
                  <Col numColSpan={1}>
                  <Title>Status MZO</Title>
                  <Dropdown
                        className='max-w-md'
                        defaultValue="all"
                        onValueChange={ (value) => setSelectedStatus(value) }
                    >
                        <DropdownItem value="all" text="Todos os status" />
                        <DropdownItem value="created" text="Criado" />
                        <DropdownItem value="transporter_allocated" text="Transportador alocado" />
                        <DropdownItem value="collected" text="Coletado" />
                        <DropdownItem value="received" text="Recebido" />
                        <DropdownItem value="en_route" text="Em rota" />
                        <DropdownItem value="delivered" text="Entregue" />
                        <DropdownItem value="cancelled" text="Cancelado" />
                        <DropdownItem value="handling" text="Em tratativa" />
                        <DropdownItem value="awaiting_return" text="Aguard. devolução" />
                        <DropdownItem value="awaiting_transfer" text="Aguard. transferência" />
                        <DropdownItem value="return_route" text="Rota devolução" />
                        <DropdownItem value="returned" text="Devolvido" />
                        <DropdownItem value="collected_not_received" text="Coletados Não Receb." />
                        <DropdownItem value="cancelled_after_received" text="Canc. após Receb." />
                        <DropdownItem className='DropTransOption' value="returned_area_not_serviced" text="Devolvido - Área não atendida" />
                        <DropdownItem className='DropTransOption' value="new_driver_allocated" text="Novo entregador alocado" />
                    </Dropdown>
                  </Col>
                  {selectedSource !== "mazelog" ? (
                    <Col numColSpan={1}>
                      {selectedSource === "mercado_livre" && (
                        <>
                            <Title>Status Canal</Title>
                            <Dropdown
                              className="max-w-md"
                              value={statusChannel}
                              onValueChange={(value) => setStatusChannel(value)}
                            >
                              <DropdownItem value="all" text="Todos os status" className="border-b mb-2" />
                              <DropdownItem value="pending" text="Pendente" />
                              <DropdownItem value="handling" text="Manuseio" />
                              <DropdownItem value="ready_to_ship" text="Pronto para envio" />
                              <DropdownItem value="shipped" text="Enviado" />
                              <DropdownItem value="shipped|bad_address" text="Endereço incorreto" />
                              <DropdownItem value="shipped|receiver_absent" text="Destinatário ausente" />
                              <DropdownItem value="delivered" text="Entregue" />
                              <DropdownItem value="not_delivered" text="Não entregue" />
                              <DropdownItem value="cancelled" text="Cancelado" />
                            </Dropdown>
                        </>
                          )}

                          {selectedSource === "shopee" && (
                            <>
                              <Title>Status Canal</Title>
                              <Dropdown
                                className="max-w-md"
                                value={statusChannel}
                                onValueChange={(value) => setStatusChannel(value)}
                              >
                                <DropdownItem value="all" text="Todos os status" className="border-b mb-2" />
                                <DropdownItem value="LOGISTICS_NOT_STARTED" text="Logística não iniciada" />
                                <DropdownItem value="LOGISTICS_REQUEST_CREATED" text="Envio solicitado" />
                                <DropdownItem value="LOGISTICS_PICKUP_DONE" text="Coletado pela transportadora" />
                                <DropdownItem value="LOGISTICS_PICKUP_RETRY" text="Reagendamento de coleta" />
                                <DropdownItem value="LOGISTICS_PICKUP_FAILED" text="Coleta falhou ou não prosseguiu" />
                                <DropdownItem value="LOGISTICS_DELIVERY_DONE" text="Entregue com sucesso" />
                                <DropdownItem value="LOGISTICS_DELIVERY_FAILED" text="Entrega falhou" />
                                <DropdownItem value="LOGISTICS_REQUEST_CANCELED" text="Envio cancelado" />
                                <DropdownItem value="LOGISTICS_COD_REJECTED" text="Pedido rejeitado (pagamento na entrega)" />
                                <DropdownItem value="LOGISTICS_READY" text="Pronto para envio (pagamento aprovado)" />
                                <DropdownItem value="LOGISTICS_INVALID" text="Pedido inválido/cancelado" />
                                <DropdownItem value="LOGISTICS_LOST" text="Pedido perdido pela transportadora" />
                                <DropdownItem value="LOGISTICS_PENDING_ARRANGE" text="Logística pendente de agendamento" />
                              </Dropdown>
                            </>
                          )}
                      </Col>
                    ) : (
                      <div></div>
                  )}
                  <Col numColSpan={1}>
                    <Toggle onValueChange={(value) => setFilterByDate(value)} value={filterByDate} color='purple' className='DateSwitch'>
                      <ToggleItem value='emission' text='Criação'>Hey</ToggleItem>
                      <ToggleItem value='update' text='Atualização'>Ho</ToggleItem>
                    </Toggle>
                  </Col>
                  <Col numColSpan={2}>
                    <div className='flex gap-2 mt-4'>
                      <Button className='FilterButton' onClick={() => handleFilter()}>
                        Buscar
                      </Button>
                    </div>
                  </Col>
                </Grid>
          <div>
          <Divider/>
            {/* <div>
              <Text>Pedidos com transportadora alocada</Text>
              <Metric>{moreOrdersToShow ? countOrders + '+' : countOrders}</Metric>
            </div> */}
            { requested ? 
                <div className="flex justify-center items-center my-10">
                  <div className="spinner h-16 w-16"></div>
                </div>
              : 
                <OperationsTableComponent selectedOrders={searchedOrders}/>
            }
          </div>
          { searchedOrders.length > 0 && (
                <ReactPaginate
                  pageCount={calculatePageCount()}
                  pageRangeDisplayed={5}
                  marginPagesDisplayed={2} 
                  onPageChange={({ selected }) => {
                    setPage(selected);
                    handleSubmit(selected);
                  }}  
                  forcePage={page}
                  containerClassName="pagination"
                  activeClassName="active"
                  previousLabel="Anterior"
                  nextLabel="Próxima"
                  breakLabel="..."
                  disabledClassName="disabled"
                />
              )}
        </Card>
      </div>
    </div>
  </main>
  );
}